var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 47,
    viewBox: "0 0 42 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5711 6.48566L34.9448 16.7304L39.4933 13.4875L20.5711 0L1.64886 13.4875L6.19736 16.7304L20.5711 6.48566Z",
    fill: "#5EB5AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.1772V46.1138H5.21202V27.2188L20.5711 38.1659L35.9301 27.2188V46.1138H41.1405V17.1772L20.5711 31.8393L0 17.1772Z",
    fill: "#5EB5AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.67a2079559bdc9efbb07869c0302f31d.svg";
export { ForwardRef as ReactComponent };